import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ConnectedSystem,
  ConnectedSystemAuth,
} from "./connectedSystem-interface";

export const fetchConnectedSystemsByApplication = createAsyncThunk(
  "connectedSystems/fetchConnectedSystemsByApplication",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/conn-systems/app-uuid/${appUuid}`);
    return response.data as ConnectedSystem[];
  }
);

export const fetchConnectedSystems = createAsyncThunk(
  "connectedSystems/fetchConnectedSystems",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/conn-systems`);
    return response.data as ConnectedSystem[];
  }
);

export const fetchConnectedSystemsById = createAsyncThunk(
  "connectedSystems/fetchConnectedSystemsById",
  async (csId: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/conn-systems/${csId}`);
    return response.data as ConnectedSystem;
  }
);

export const fetchConnectedSystemAuths = createAsyncThunk(
  "connectedSystems/fetchConnectedSystemAuths",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_http_conn_auth`);
    return response.data as ConnectedSystemAuth[];
  }
);
